import { useEffect, useState } from "react"
import { collectionGroup, getDocs, getFirestore, query, orderBy, collection } from "firebase/firestore"
import { db } from "../../../../services/firebase"
import "../style/WithdrawalsPanel.scss"

type Withdrawal = {
  userId: string
  amount: number
  asset: string
  timestamp: any
}

type UserMap = Record<string, string>

const WithdrawalsPanel = () => {
  const [withdrawals, setWithdrawals] = useState<Withdrawal[]>([])
  const [userMap, setUserMap] = useState<UserMap>({})


  useEffect(() => {
    const fetchData = async () => {
      // 1. Fetch users and build a map of userId -> name
      const userSnap = await getDocs(collection(db, "users"))
      const userMap: UserMap = {}
      userSnap.forEach(doc => {
        const data = doc.data()
        userMap[doc.id] = data.displayName || data.email || "Unknown"
      })
      setUserMap(userMap)

      // 2. Fetch all withdrawals from all subcollections
      const q = query(collectionGroup(db, "withdrawals"), orderBy("timestamp", "desc"))
      const snap = await getDocs(q)

      const all = snap.docs.map(doc => ({
        ...doc.data(),
        userId: doc.ref.path.split("/")[1] // 👈 Extract userId from path
      })) as Withdrawal[]

      setWithdrawals(all)
    }

    fetchData()
  }, [])

  return (
    <div className="admin-panel">
      <h2>Recent Withdrawals</h2>
      <table>
        <thead>
          <tr>
            <th>User</th>
            <th>Asset</th>
            <th>Amount</th>
            <th>Timestamp</th>
          </tr>
        </thead>
        <tbody>
          {withdrawals.map((w, idx) => (
            <tr key={idx}>
              <td>{userMap[w.userId] || w.userId}</td>
              <td>{w.asset}</td>
              <td>{w.amount}</td>
              <td>{new Date(w.timestamp?.toDate?.() || "").toLocaleString()}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  )
}

export default WithdrawalsPanel
